import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import NewsCards from 'components/NewsCards';
import TagsFilter from 'components/TagsFilter';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNews } from 'store/getNewsSlice';
import { useEffect } from 'react';
import React from 'react';

const News = () => {
    const dispatch = useDispatch();
    // @ts-ignore
    const {
        title,
        description,
        posts,
        tags,
        title_background,
        subscribe_title,
        subscribe_description,
        subscribe_policy_text,
        // TODO recheck all field and add
    } = useSelector(state => state?.news?.data?.data) || {};

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchNews());
    }, [dispatch]);

    const [selectedTag, setSelectedTag] = React.useState('show all');
    const handleClick = name => setSelectedTag(name);

    const filteredPosts = selectedTag === 'show all' ? posts : posts.filter(post => post.type === selectedTag);

    return (
        <>
            <Banner title={title} image={title_background} buttonText="!! field_name ? " />

            <section className="container">
                <div className="inner-container">
                    <div className="news-heading">
                        <GradientText size="small">
                            <div className="max-width-760">
                                {/* We're constantly <em>publishing fresh news and research</em>, that will help expand your
                                knowledge of the current <em>challenges in the agricultural industry</em>. */}
                                <span dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                        </GradientText>
                        <TagsFilter tags={tags} selectedTag={selectedTag} onClick={handleClick} />
                    </div>
                    {/* TODO do firsc news card big */}
                    <NewsCards
                        posts={filteredPosts}
                        subscribeTitle={subscribe_title}
                        subscribeDescription={subscribe_description}
                        subscribePolicy={subscribe_policy_text}
                    />
                    {/* <Button type="show-more" className="full-width">
                        SHOW MORE
                    </Button> */}
                </div>
            </section>
        </>
    );
};

export default News;
